import { sendEmail } from "@/services/mails/mailService";
import { createModel } from "@rematch/core";

const initialState: {} = {
  isloaded: false,
  mails: [],
  mailsList: [],
};
export const mailModel = createModel()({
  state: { ...initialState },
  reducers: {
    UPDATE: (state, key, value) => {
      return {
        ...state,
        [key]: value,
      };
    },
    setMails(state, res) {
      return {
        ...state,
        mails: res.data,
      };
    },
    setMailsList(state, res) {
      return {
        ...state,
        mailsList: res,
      };
    },
  },
  effects: (dispatch) => ({
    async sendEmail(x) {
      const response = await sendEmail(x);
      if (response) {
        console.log(response);

        return response;
      } else {
        return {};
      }
    },
  }),
});
